import React from 'react';
import i18n from 'i18next';

import { Loading } from 'uikit/loaders';
import { Typo } from 'uikit/content';
import ProfileChallengesContainer from '../containers/profileChallengesContainer';
import ProfileCredentialsContainer from '../containers/profileCredentialsContainer';
import ProfileSkillsContainer from '../containers/profileSkillsContainer';
import ProfileGold from './profileGold';
import ProfileHero from './profileHero';

import styles from '../styles/profile.module.scss';

const Profile = ({
  goldCount,
  goldRedeemURL,
  profile,
  isCurrentUser,
  isGoldEnabled,
  isGoldLimitReached,
  isReputationEnabled,
  isLoading,
  isShowingChallenges,
  onEditTopicsClick,
  onTopicsFollowedClick,
  onViewHistoryClick,
  isSpeakerProfile,
  className,
}) => {
  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <ProfileHero
        profile={profile}
        isCurrentUser={isCurrentUser}
        isReputationEnabled={isReputationEnabled}
        isLoading={isLoading}
        onTopicsFollowedClick={onTopicsFollowedClick}
        onEditTopicsClick={onEditTopicsClick}
        className={className}
      />
      {isGoldEnabled && isCurrentUser && !isSpeakerProfile && (
        <ProfileGold
          goldCount={goldCount}
          goldRedeemURL={goldRedeemURL}
          isGoldLimitReached={isGoldLimitReached}
          onViewHistoryClick={onViewHistoryClick}
        />
      )}
      {!isSpeakerProfile && (
        <div className={styles.content}>
          <div className={styles.inner}>
            {!profile.reputation_points &&
              !profile.credentials_count &&
              !profile.trophies_count &&
              !isCurrentUser && (
                <div className={styles.placeholder}>
                  <Typo element="h2" variant="d02">
                    {i18n.t('its-empty-in-here')}
                  </Typo>
                  <Typo element="p" variant="b01">
                    {i18n.t('its-empty-in-here-description', {
                      name: `${profile.first_name} ${profile.last_name}`,
                    })}
                  </Typo>
                </div>
              )}
            {isReputationEnabled && (!!profile.reputation_points || isCurrentUser) && (
              <ProfileSkillsContainer />
            )}
            {!!profile.credentials_count && <ProfileCredentialsContainer />}
            {isShowingChallenges && <ProfileChallengesContainer />}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(Profile);
